import { getAppConfigSetting } from "../../../utils";

export const GET_LOGIN_TYPE_REQUEST = "GET_LOGIN_TYPE_REQUEST";
export const GET_LOGIN_TYPE_SUCCESS = "GET_LOGIN_TYPE_SUCCESS";
export const GET_LOGIN_TYPE_FAILURE = "GET_LOGIN_TYPE_FAILURE";

export const URL = `${getAppConfigSetting(
  "legitApiUrl"
)}/legit/api/v2/session/logintype`;
